/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {submitDelegatedOauth} from '../api'

export const useMutationSubmitDelegatedOauth = createReactQueryMutationHook('submitDelegatedOauth', submitDelegatedOauth)
